import { PhotoIndexInfo } from "../interfaces/PhotoIndexInfo.interface";

export class ChangeInsideSurveyPhotoIndexDTO {
  id: string;
  photosIndexInfo: PhotoIndexInfo[];

  constructor(dto: Partial<ChangeInsideSurveyPhotoIndexDTO>) {
    Object.assign(this, dto);
  }
}
